import axios from "axios";
import { APIS } from "../utils/api-factory";
import {POST_HEADER} from '../../../../../utils/apiHeaders'

export const getCommunityCountApi = (data, ParentcommunityId, commType, callBack, error) => {
  const headerConfig = {
    headers: {},
  };

  axios
    .get(
      APIS.GET_COMMUNITY_COUNT +
      data.emailId +
      "&mobileNumber=" +
      data.mobileNo +
      "&communityCode=" +
      data.communityCode +
      "&whoYouAre=" +
      data.whoYouAre +
      "&important=" +
      data.important +
      "&parentCommunityId=" +
      ParentcommunityId +
      "&createdOn=" +
      (data.createdOn != null && data.createdOn != undefined
        ? data.createdOn
        : "")
      + "&communityType=" + commType + "&communityName=" + data.name,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getCommunityApi = (pageNo, noOfRows, data, ParentcommunityId, commType, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  let commCode = data.communityCode !== undefined ? data.communityCode : "";

  axios
    .get(
      APIS.GET_COMMUNITY +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&emailId=" +
      data.emailId +
      "&whoYouAre=" +
      data.whoYouAre +
      "&important=" +
      data.important +
      "&communityCode=" +
      commCode +
      "&mobileNo=" +
      data.mobileNo +
      "&parentCommunityId=" +
      ParentcommunityId +
      "&createdOn=" +
      (data.createdOn != null && data.createdOn != undefined
        ? data.createdOn
        : "")
      + "&communityType=" + commType + "&communityName=" + data.name,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const deleteCommunityApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .delete(APIS.DELETE_COMMUNITY + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const markImp = (communityId, flag, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.MARK_COMMUNITY_AS_IMP + communityId + "&flag=" + flag,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res);
    });
};


export const changeParentOfCommunityMember = (emailId, communityCode, communityId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.CHANGE_PARENT_COMMUNITY + emailId + '&communityCode=' + communityCode + '&communityId=' + communityId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      console.log(e)
      // error(e.res.data)
    })
}

export const getDashboardTreeApi = (comId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_GET_DASHBOARD_TREE + comId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error(e)
    })
}

export const getnewTreeApi = (communityId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.NEW_TREE_API + communityId + '&level=3', headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      console.log(e)
      // error(e.res.data)
    })
}

export const getCommunityPersonalApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_COMMUNITY_PERSONAL + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getCommunityProfessionalApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_COMMUNITY_PROFESSIONAL + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getDocumentDetailApi = (
  pageNo,
  noOfRows,
  communityId,
  callBack,
  error
) => {

  const lenderId = "";
  const licenseId = "";

  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DOCUMENT_DETAIL +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&lenderId=" +
      lenderId +
      "&licenseId=" +
      licenseId +
      "&communityId=" +
      communityId,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res);
    });
};


export const getAddressDetailCommunityApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_ADDRESS_DETAIL_COMMUNITY + id + "&type=", headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.message);
    });
};

export const getBankDetailCommunityApi = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_BANK_DETAIL_COMMUNITY + id, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getChapterDetailsByChapterId = (chapterId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_CHAPTER_DETAILS_BY_CHAPTER_ID + chapterId, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      error(e.res);
    });
};

export const sendCompleteProfileLink = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.SEND_COMPLETE_PROFILE_LINK + data, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const sendWelcomeMail = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .post(APIS.SEND_WELCOME_MAIL + data, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const sendDocumentLink = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.SEND_DOCUMENT_LINK + data, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const saveUpdateDocumentApiOther = (
  file,
  docName,
  id,
  rowData,
  description,
  replaceOrUpload,
  callBack,
  error
) => {
  const type =
    file.type === "image/png"
      ? "img"
      : file.type === "application/pdf"
        ? "pdf"
        : file.type === "image/jpg"
          ? "img"
          : file.type === "image/jpeg"
            ? "img"
            : "";
  const headerConfig = {
    headers: {},
  };
  let multipartFormData = new FormData();
  multipartFormData.append("docName", docName);
  multipartFormData.append("description", description);
  multipartFormData.append("file", file);
  multipartFormData.append("documentId", id ? id : "");
  multipartFormData.append("type", type);
  multipartFormData.append("fileName", file.name);
  multipartFormData.append(
    "lenderId",
    rowData.lenderId !== undefined ? rowData.lenderId : ""
  );
  multipartFormData.append(
    "licenseId",
    rowData.licenseId ? rowData.licenseId : LICENCE_ID
  );
  multipartFormData.append(
    "userId",
    rowData.userId !== undefined ? rowData.userId : ""
  );
  multipartFormData.append(
    "loanId",
    rowData.loanId !== undefined ? rowData.loanId : ""
  );
  multipartFormData.append(
    "communityId",
    rowData && rowData.communityId
      ? rowData.communityId
      : window.sessionStorage.getItem("communityId")
  );
  multipartFormData.append("replaceOrUpload", replaceOrUpload);

  axios
    .post(APIS.UPLOAD_OTHER_DOCUMENTS, multipartFormData, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const searchDocName = (name, callBack) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_DOC_NAME_SEARCH + name, headerConfig)
    .then(res => {
      callBack(res.data)
    })

}


export const getNumbertOfMembersApi = (communityId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.COM_GET_NUMBER_OF_MEMBERS +
      communityId,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getNumbertOfLeadsGeneratedApi = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.COM_GET_NUMBER_OF_LEADS_GENERATED + data +
      "&dateFrom=" +
      "" +
      "&dateTo=" +
      "",
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getLeadsStatusApi = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.COM_GET_LEADS_STATUS +
      data +
      "&dateFrom=" +
      "" +
      "&dateTo=" +
      "",
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getCommunityDashboardData = (
  communityId,
  graphType,
  callBack,
  error
) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_COMMUNITY_DASHBOARD_DATA +
      communityId +
      "&graphType=" +
      graphType,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const CommunityLeadGetUserApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      console.log(e)
      // error(e.res.data)
    })
}
export const CommunityLeadGetUserLoanApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_LOAN + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
      console.log(e);
    })
}
export const getActivityApi = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_ACTIVITY_API + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const LenderGetAllLeadsApi = (pageNo, noOfRows, phoneNo, email, leadType, applyDate, loanType, lenderIdParam, loanStatusParam, communityId, qrId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  console.log(communityId, "    sdcknnjskckslmcklscmlks   ");
  const lenderId = window.sessionStorage.getItem('lenderId') !== null ? window.sessionStorage.getItem('lenderId') : lenderIdParam
  const lenderEmp = window.sessionStorage.getItem('lenderEmployeeId') !== null ? window.sessionStorage.getItem('lenderEmployeeId') : ''
  const loanStatus = loanStatusParam ? loanStatusParam : ''
  axios.get(APIS.LENDER_GET_LOAN_LEADS + pageNo + '&noOfEntry=' + noOfRows + '&lenderId=' + lenderId + '&communityId=' + communityId + "&qrCodeId=" + qrId + '&phoneNo=' + phoneNo + '&email=' + email + '&leadType=' + leadType + '&loanType=' + loanType + '&appliedDate=' + applyDate + "&lenderEmployeeId=" + lenderEmp + '&loanStatus=' + loanStatus, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const LenderGetAllLeadsCountApi = (email, phoneNo, leadType, loanType, appliedDate, communityId, qrId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  const lenderId = window.sessionStorage.getItem('lenderId') !== null ? window.sessionStorage.getItem('lenderId') : ''
  axios.get(APIS.LENDER_GET_LOAN_LEAD_COUNT + lenderId + '&communityId=' + communityId + '&applicationId=' + '' + "&qrCodeId=" + qrId + '&email=' + email + '&phoneNo=' + phoneNo + '&pinCode=' + '' + '&city=' + '' + '&state=' + '' + '&loanStatus=' + '' + '&leadType=' + leadType + '&loanType=' + loanType + '&appliedDate=' + appliedDate, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveLenderComments = (data, comment, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  console.log(data, "LEnderComments")
  const myData = {
    'loanId': data.loanId,
    // 'userId': data.userId,
    'applicationId': data.applicationId,
    'lenderId': window.sessionStorage.getItem('lenderId'),
    'body': comment
  }
  // console.log("data ",data)

  axios.post(APIS.SAVE_LENDER_COMMENTS, myData, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const assignLenderApi = (lenderId, loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.ASSIGN_LENDER_API + lenderId + '&loanId=' + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })

}

export const assignEmployee = (empId, loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.ASSIGN_EMPLOYEE_LOAN + empId + "&loanId=" + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}
export const assignMultipleLenders = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.ASSIGN_LENDER_LIST_API, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getAsssignedLenderList = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_LENDER_LIST + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}
export const assignLenderEmployee = (empId, loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  let lenderId = window.sessionStorage.getItem("lenderId")
  axios.get(APIS.ASSIGN_LENDER_EMP + loanId + "&empId=" + empId + "&lenderId=" + lenderId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getLenderEmployee = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_LENDER_EMPLOYEE + window.sessionStorage.getItem("lenderId"), headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const deleteLeadAdmin = (userId, loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.delete(APIS.DELETE_ADMIN_LEAD + userId + '&loanId=' + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getLendersCountApi = (search, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_LENDER_COUNT +
      search.emailId +
      "&mobileNumber=" +
      search.mobileNumber,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res);
    });
};

export const getLenderApi = (pageNo, noOfRows, data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_LENDER +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&emailId=" +
      data.emailId +
      "&mobileNumber=" +
      data.mobileNumber,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getUserCountApi = (search, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_USER_TABLE_COUNT +
      search.emailId +
      "&mobileNo=" +
      search.mobileNo,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getUsersApi = (pageNo, noOfRows, search, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_USERS +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&emailId=" +
      search.emailId +
      "&mobileNo=" +
      search.mobileNo,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};


export const getWorkflowApi = (pageNo, noOfRows, data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_WORKFLOW +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&lenderId=" +
      data.lenderId +
      "&licenseId=" +
      data.licenseId +
      "&type=" +
      data.type,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const CommunityLeadGetUserBusinessApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_BUSINESS + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      callBack("")
      // error(e.res.data)
    })
}

export const CommunityLeadGetUserAddressApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_ADDRESS + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const CommunityLeadGetUserBankApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_BANK + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const CommunityLeadGetUserSalaryApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_SALARIED + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const CommunityLeadGetUserPropertyByUserIdApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_PROPERTY_BY_USERID + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const CommunityLeadGetUserDirectorByUserIdApi = (userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_DIRECTOR_BY_USERID + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const CommunityLeadSaveUserLoanApi = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.COM_LEAD_SAVE_USER_LOAN, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getStoryLines = (loanId, pageNo, noOfEntry, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_STORY_LINE + loanId + "&pageNo=" + pageNo + "&noOfEntry=" + noOfEntry, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const generateCustomLink = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.GENERATE_CUSTOM_LINK, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getCustomLink = (linkId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_CUSTOM_LINK + linkId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const getCustomLinkByLoanId = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_CUSTOM_LINK_BY_LOANID + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const getBankMatchingData = (search, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_BANK_SEARCH_DATA_MATCHING + search, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getBankMatchingDataWithId = (search, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_BANK_SEARCH_DATA_MATCHING_WITH_ID + search, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getNbfcMatchingDataWithId = (search, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(APIS.GET_NBFC_SEARCH_DATA_MATCHING_WITH_ID + search, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getWorkflowCountApi = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_WORKFLOW_TABLE_COUNT +
      data.lenderId +
      "&licenseId=" +
      data.licenseId +
      "&type=" +
      data.type,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const SaveApplicationStatusApi = (loanId, status, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.SAVE_APPLICATION_STATUS + loanId + '&status=' + status + '&empId=' + window.sessionStorage.getItem('emailId') + '&comment=', headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const DisburseApplicationStatusApi = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.DISBURSE_APPLICATION + data.loanId + '&date=' + data.date + '&empId=' + window.sessionStorage.getItem('emailId') + '&amount=' + data.amount, {}, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const ApproveApplicationStatusApi = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.APPROVE_APPLICATION, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const geLoanEmiApi = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_LOAN_EMI + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const geLoanActivityApi = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_LOAN_ACTIVITY + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const saveStickyNotes = (loanId, operationId, comment, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  const myData = {

    'body': comment
  }
  // console.log("data ",data)

  axios.post(APIS.SAVE_STICKY_NOTES + loanId + '&operationId=' + operationId, comment, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getStickyNotes = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };


  axios.post(APIS.GET_STICKY_NOTES + loanId + '&operationId=' + window.sessionStorage.getItem('emailId'), headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const deleteTasks = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.delete(APIS.DELETE_TASKS + id, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const getTasks = (loanId, month, year, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_TASKS + loanId + "&month=" + month + "&year=" + year, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const saveTask = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_TASKS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const updateTasks = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.put(APIS.UPDATE_TASKS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const getEmiDetailsApi = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_EMI_DETAILS_API + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const getCrifDataByUserIdtest = (userId, callBack) => {
  fetch(
    APIS.GET_CRIF_DATA_BY_USER_ID + userId)
    .then(res => res.text())
    .then(res => {
      callBack(res)
    })

}

export const getAuTomationDoc = (userId, callBack) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_AUTOMATION_DOC + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })

}

export const getUploadedDocumentsApi = (userId, callBack) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_DOCUMENT_DETAIL + 1 + '&noOfEntry=' + 500 + '&userId=' + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })

}

export const mapAutomationDocApi = (rowData, changeData, callBack) => {
  const headerConfig = {
    headers: {},
  };
  let data = {
    'documentId': changeData.documentId ? changeData.documentId : '',
    'url': changeData.url,
    'type': changeData.type,
    'docName': changeData.docName,
    'description': changeData.description,
    'lenderId': rowData.lenderId,
    'licenseId': rowData.licenseId,
    'communityId': rowData.communityId,
    'userId': rowData.userId,
    'loanId': rowData.loanId,
    'replaceOrUpload': 0,
    'empEmail': window.sessionStorage.getItem('emailId')
  }
  axios.post(APIS.MAP_AUTOMATION_DOC, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })

}

// Add Documents 

export const uploadzip = (file, type, loanId, userId, docName, docDescription, callBack, error) => {
  console.log(file.type)
  const headerConfig = {
    headers: {},
  };
  let multipartFormData = new FormData()

  multipartFormData.append('file', file)
  multipartFormData.append('loanId', loanId)
  multipartFormData.append('userId', userId)
  multipartFormData.append('type', type)  // direct or extract
  multipartFormData.append('documentName', docName)
  multipartFormData.append('description', docDescription)

  axios.post(APIS.UPLOAD_ZIP_FILE, multipartFormData, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })


}


export const saveUpdateDocumentApi = (file, id, rowData, callBack, error) => {
  console.log(rowData, "rowdata");
  const headerConfig = {
    headers: {},
  };
  // console.log(rowData.licenseId)
  const type =
    file.type === "image/png"
      ? "img"
      : file.type === "application/pdf"
        ? "pdf"
        : file.type === "image/jpg"
          ? "img"
          : file.type === "image/jpeg"
            ? "img"
            : "";
  let multipartFormData = new FormData();
  multipartFormData.append(
    "replaceOrUpload",
    rowData.uploadedOrNot === "N" ? 0 : 1
  );

  multipartFormData.append("file", file);
  multipartFormData.append("documentId", id);
  multipartFormData.append("type", type);
  multipartFormData.append("fileName", file.name);
  multipartFormData.append(
    "lenderId",
    rowData.lenderId !== undefined ? rowData.lenderId : ""
  );
  multipartFormData.append(
    "licenseId",
    rowData.licenseId ? rowData.licenseId : LICENCE_ID
  );
  multipartFormData.append(
    "userId",
    rowData.userId !== undefined ? rowData.userId : ""
  );
  multipartFormData.append(
    "loanId",
    rowData.loanId !== undefined ? rowData.loanId : ""
  );
  multipartFormData.append(
    "communityId",
    rowData && rowData.communityId
      ? rowData.communityId
      : window.sessionStorage.getItem("communityId")
  );

  // if (rowData.communityId !== null && rowData.communityId !== undefined) {
  //     multipartFormData.append('communityId', rowData.communityId)
  // }
  axios
    .post(APIS.SAVE_UPDATE_DOCUMENT, multipartFormData, headerConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getDocumentConfigApi = (
  pageNo,
  noOfRows,
  data,
  callBack,
  error
) => {
  console.log(data, "data");
  const licenseId = data.licenseId ? data.licenseId : LICENCE_ID;
  const product = data.product !== undefined ? data.product : "";
  const bussinessType =
    data.bussinessType !== undefined ? data.bussinessType : "";
  const sourceOfIncome =
    data.sourceOfIncome !== undefined ? data.sourceOfIncome : "";
  const loanId = data.loanId !== undefined ? data.loanId : "";
  const communityId = data.communityId !== undefined ? data.communityId : "";
  const lenderId = data.lenderId !== undefined ? data.lenderId : "";
  const stage = data.stage !== undefined ? data.stage : "";

  const headerConfig = {
    headers: {},
  };
  console.log(data);
  axios
    .get(
      APIS.GET_DOCUMENT_CONFIG +
      pageNo +
      "&noOfEntry=" +
      noOfRows +
      "&licenseId=" +
      licenseId +
      "&product=" +
      product +
      "&bussinessType=" +
      bussinessType +
      "&sourceOfIncome=" +
      sourceOfIncome +
      "&loanId=" +
      loanId +
      "&communityId=" +
      communityId +
      "&lenderId=" +
      lenderId +
      "&stage=" +
      stage,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getDocumentCountApi = (data, callBack, error) => {
  const licenseId = data.licenseId ? data.licenseId : LICENCE_ID;
  const product = data.product !== undefined ? data.product : "";
  const headerConfig = {
    headers: {},
  };
  axios
    .get(
      APIS.GET_DOCUMENT_TABLE_COUNT + licenseId + "&product=" + product,
      headerConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((e) => {
      // error(e.res.data);
    });
};

export const getCommission = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_COMMISSION_BY_LOANID + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getTimeSpent = (loanId, type, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_TIME_SPENT + loanId + "&unit=" + type, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const saveCommission = (commission, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_COMMISSION, commission, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const startOrStopTimer = (loanId, timer, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.START_OR_STOP_TIMER + loanId + "&timer=" + timer, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const updateCommissionByLoanId = (loanId, commission, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.UPDATE_COMMISSION_BY_LOANID + loanId + "&commissionAmt=" + commission, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

// comments 
export const getCommentData = (loanId, callBack) => {
  fetch(
    APIS.GET_COMMENTS + loanId)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })

}

export const deleteComment = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.delete(APIS.DELETE_COMMENT + id, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const readComments = (loanId, lenderId, communityId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.READ_COMMENTS + loanId + "&lenderId=" + lenderId + "&communityId=" + communityId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveAdminComments = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };


  axios.post(APIS.SAVE_LENDER_COMMENTS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveCommunityComments = (data, comment, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  console.log(data, "LEnderComments")
  const myData = {
    'loanId': data.loanId,
    // 'userId': data.userId,
    'applicationId': data.applicationId,
    'communityId': data.communityId,
    'body': comment
  }
  // console.log("data ",data)

  axios.post(APIS.SAVE_LENDER_COMMENTS, myData, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getAssignedLenders = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_ASSIGNED_LENDERS_BY_LOANID + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getCommentDataByLenderIdAdmin = (loanId, lenderId, callBack) => {
  fetch(
    APIS.GET_COMMENTS + loanId + '&lenderId=' + lenderId)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })

}

export const getCommentDataByUserIdAdmin = (loanId, userId, callBack) => {
  fetch(
    APIS.GET_COMMENTS + loanId + '&userId=' + userId)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })

}

export const getCommentDataByCommmunityIdAdmin = (loanId, communityId, callBack) => {
  fetch(
    APIS.GET_COMMENTS + loanId + '&communityId=' + communityId)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })

}

export const getCommentDataByOperationId = (loanId, operationId, callBack) => {
  fetch(
    APIS.GET_COMMENTS + loanId + '&operationId=' + operationId)
    .then(res => res.json())
    .then(res => {
      callBack(res)
    })

}

export const pokeMsg = (id, loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.POKE + id + "&loanId=" + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const resetRemainder = (loanId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.RESET_REMAINDER + loanId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const getSheetUrl = (loanId, applicationId, userId, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_SHEET_URL + loanId + "&applicationId=" + applicationId + "&userId=" + userId, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      error('')
    })
}

export const deleteChallenge = (id, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.delete(APIS.DEL_CHALLENGE + id, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getChallenges = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_CHALLENGE + data.loanId + "&pageNo=" + data.pageNo + "&noOfEntry=" + data.noOfEntry, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const saveChallenge = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_CHALLENGE, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const getOEMDetailsByMakeclass = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_OEM_DETAILS_BY_MAKE_CLASS, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateOEMDetails = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_UPDATE_OEM_DETAILS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateOEMEvScorecard = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_UPDATE_EVOEM_SCORECARD, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getProductOfCommunityIdbyCommunityId = (commId, callBack, error) => {

  axios.get(APIS.GET_PRODUCT_OF_COMMUNITYID_BY_COMMUNITYID + commId)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getMappedProductDetailsBycommId = (commId, callBack, error) => {

  axios.get(APIS.GET_MAPPED_PRODUCT_DETAILS_BY_COMMUNITYID + commId)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}
export const getUnMappedProductDetailsBycommId = (commId, callBack, error) => {

  axios.get(APIS.GET_UNMAPPED_PRODUCT_DETAILS_BY_COMMUNITYID + commId)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const SaveUpdatecommunityToProduct = (data, callBack, error) => {

  axios.post(APIS.SAVE_UPDATE_COMMUNIYT_TO_PRODUCT, data)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const DeletecommunityToProduct = (communityId, productId, callBack, error) => {

  axios.delete(APIS.DELETE_COMMUNIYT_TO_PRODUCT + communityId + "&productId=" + productId)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getCommunityOEMDetailsById = (communityId, vehicleType, pageNo, noOfEntry, callBack, error) => {

  axios.get(APIS.GET_COMMUNITY_TOOEM_DETAILS_BY_ID + communityId + "&vehicleType=" + vehicleType + "&pageNo=" + pageNo + "&noOfEntry=" + noOfEntry)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getCommunityOEMDetailsCountById = (communityId, vehicleType, callBack, error) => {

  axios.get(APIS.GET_COMMUNITY_TOOEM_DETAILS_COUNT_BY_ID + communityId + "&vehicleType=" + vehicleType)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getUnmappedCommunityOEMDetailsById = (communityId, vehicleType, pageNo, noOfEntry, callBack, error) => {

  axios.get(APIS.GET_UNMAPPED_COMMUNITY_TOOEM_DETAILS_BY_ID + communityId + "&vehicleType=" + vehicleType + "&pageNo=" + pageNo + "&noOfEntry=" + noOfEntry)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getUnmappedCommunityOEMDetailsCountById = (communityId, vehicleType, callBack, error) => {

  axios.get(APIS.GET_UNMAPPED_COMMUNITY_TOOEM_DETAILS_COUNT_BY_ID + communityId + "&vehicleType=" + vehicleType)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateCommunityToOemDetails = (data, callBack, error) => {

  axios.post(APIS.SAVE_UPDATE_COMMUNITY_TO_OEM_DETAILS, data)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const DeleteCommunityToOemDetails = (communityId, oemId, callBack, error) => {

  axios.delete(APIS.DELETE_COMMUNITY_TO_OEM_DETAILS + communityId + "&oemId=" + oemId)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const getVehicleTypeListById = (communityId, mapped, callBack, error) => {

  axios.get(APIS.GET_VEHICLE_TYPE_LIST_BY_COMMUNITY + communityId + "&mapped=" + mapped)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getOEMBatteryDetails = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_BATTERY_OEM_DETAILS, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateOEMBatteryDetails = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_UPDATE_BATTERY_ORM_DETAILS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const getDealerMappedinAMuAgentBycommId = (commId, isMapped, callBack, error) => {

  axios.get(APIS.GET_MAPPING_DETAILS_FOR_AMU_AGENT + commId + "&mappedOrNot=" + isMapped)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const SaveUpdatedMappedDealer = (data, callBack, error) => {

  axios.post(APIS.SAVE_MAPPED_UNMAPPED_DEALER + data?.parentCommunityId + "&communityId=" + data?.communityId + "&mappedOrNot=" + data?.mappedOrNot)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getDashboardDataForAMuagentByDate = (data, callBack, error) => {

  axios.get(APIS.GET_DASHBOARD_DATA_FOR_AMU_AGENT_BY_DATE + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getDealerWisAgentPerformanceByDate = (data, callBack, error) => {

  axios.get(APIS.GET_DEALER_WISE_AGENT_PERFORMANCE_BY_DATE + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate + "&filterType=" + data?.filterType)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}
export const getLeadageingPerformanceForAmuAgent = (data, callBack, error) => {

  axios.get(APIS.GET_LEAD_AGEING_PERFROMANCE_FOR_AMU_AGENT + data?.communityId + "&filterType=" + data?.filterType + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getAvgTatGraphforAmuAgent = (data, callBack, error) => {

  axios.get(APIS.GET_AVG_TAT_GRAPH_FOR_AMU_AGENT + data?.communityId + "&filterType=" + data?.filterType + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const GetCommunityDashboardDataById = (data, callBack, error) => {

  axios.get(APIS.GET_COMMUNITY_DASHBOARD_DATA_BY_ID_DATE + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getConversionOvertimebyId = (data, callBack, error) => {

  axios.get(APIS.GET_CONVERSION_OVERTIME_GRAPH_BYID + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate + "&type=monthly")
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getTopPerfomanceVehicleDetailById = (data, callBack, error) => {

  axios.get(APIS.GET_TOP_PERFORMANCE_VEHICLE_DETAIL_BY_ID + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getCONTRIBUTIONGarphForDealerById = (data, callBack, error) => {

  axios.get(APIS.GET_CONTRIBUTION_GRAPH_FOR_DEALER_BY_ID + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getAgentDashboardDetailById = (data, callBack, error) => {

  axios.get(APIS.GET_AGENT_DASHBOARD_DETAIL_BY_ID + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const getSalesLeadconversionById = (data, callBack, error) => {

  axios.get(APIS.GET_SALES_LEAD_CONVERSION_STATS_BY_ID + data?.communityId + "&sDate=" + data?.sDate + "&eDate=" + data?.eDate + "&filterType=" + data?.filterType)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}
export const downloadcommunityReportByData = (start, end, type, active, callBack, error) => {

  axios.get(APIS.DOWNLOAD_COMMUNITY_REPORT_BY_DATE + start + "&endDate=" + end + "&communityType=" + type + "&active=" + active, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
    .then(res => {
     
      const contentType = res.headers['content-type'] || 'application/vnd.ms-excel';
      console.log('Response content type:', contentType);
      console.log('Response headers:', res.headers);
      let fileExtension = '.xls';
      let mimeType = 'application/vnd.ms-excel';
      
      if (contentType.includes('openxmlformats') || contentType.includes('xlsx')) {
        fileExtension = '.xlsx';
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (contentType.includes('csv')) {
        fileExtension = '.csv';
        mimeType = 'text/csv';
      }
      
      const blob = new Blob([res.data], { type: mimeType });
      
      const downloadUrl = URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${type}_report${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      
      document.body.removeChild(a);
      URL.revokeObjectURL(downloadUrl);
      
      callBack("");
    })
    .catch(e => {
      callBack("")

    })
}